$(document).ready(function () {
  //Take to shooping cart
  if ($('#salesBanner').length) {
    let salesBannerHeight = Math.floor($('#salesBanner').height());

    if ($('#salesBanner').hasClass('isSticky')) {
      $('#salesBanner, .btn:not(.cta):not(.play), .bannerSpecial, #promoBanner').on('click', function (event) {
        $('html, body').animate({
          scrollTop: $("#topSection").offset().top - salesBannerHeight
        }, 1000);
      });
    } else {
      $('#salesBanner, .btn:not(.cta):not(.play), .bannerSpecial, #promoBanner').on('click', function (event) {
        $('html, body').animate({
          scrollTop: $("#topSection").offset().top
        }, 1000);
      });
    }

  } else {
    $('.btn:not(.cta):not(.play), .bannerSpecial, #promoBanner').on('click', function (event) {
      if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
        $('html, body').animate({
          scrollTop: $("#promoBannerAnchor").offset().top
        }, 1000);
      } else {
        $('html, body').animate({
          scrollTop: $("#topSection").offset().top
        }, 1000);
      }
    });
  }

  $('.tabs .items').slick({
    speed: 300,
    centerMode: false,
    adaptiveHeight: true,
    dots: true,
    appendDots: $(".tabs .nav"),
    customPaging: function (slick, index) {
      var title = slick.$slides.eq(index).find('.item').attr('data-title');
      return ' <div class="item">' + title + '</div>'
    }
  });

  if($('#reviewsComment').length) {
    $('#reviewsComment').slick({
      slidesToShow: 1,
      arrows: true,
      dots: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: false
    });
  }


  //Shopping Cart 
  function activeProduct() {
    let thisProduct = $(this);
    // const subscribe = thisProduct.find('.purchaseTypeWrap .purchaseType input[type=checkbox]:checked').val();
    // const subscribe = thisProduct.find('.purchaseTypeWrap .purchaseType input[type=checkbox]:checked').is(":checked");
    const subscribeAttr = $('.cart__details').attr('data-check');

    let checkboxType,
      price = 'data-price',
      link = 'data-link',
      ship = 'data-shipping',
      retail = 'data-retail',
      amount = thisProduct.attr('data-units'),
      badge = thisProduct.attr('data-badge'),
      subscribe = '',
      sale = '';

    if (subscribeAttr === 'subscribe') {
      subscribe = '-subscribe';

      checkboxType = true;

    } else {
      checkboxType = false;
    }

    if ($('body').hasClass('show-promoBanner')) {
      sale = '-sale';
    }

    //- handle product buttons
    $('.cart__product').removeClass('active');
    thisProduct.addClass('active');

    //- control UI for each product amount + badge
    $('#orderNow').removeClass(function (index, className) {
      return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
    }).addClass('cart--unit' + amount);

    $('.badge').removeClass(function (index, className) {
      return (className.match(/(^|\s)badge--unit\S+/g) || []).join(' ');
    }).addClass('badge--unit' + amount);

    $('.badge__value').html(badge);

    let savingVal = thisProduct.attr(retail) - thisProduct.attr(price + subscribe + sale);
    let memberVal = thisProduct.attr(price + sale) - thisProduct.attr(price + '-subscribe');

    //- print triggered values
    $('.price').html('$' + thisProduct.attr(price + subscribe + sale));
    $('.retail__value').html('$' + thisProduct.attr(retail));
    $('.saving__value').html('$' + parseFloat(savingVal).toFixed(2));
    $('.member__value').html('$' + parseFloat(memberVal).toFixed(2));
    $('.shipping__value').html(thisProduct.attr(ship + subscribe));

    $('#purchaseMode input[type=checkbox]').attr("checked", checkboxType);

    let param = $('.summary .btn').attr('data-param');
    $('.summary .btn').attr('href', (thisProduct.attr(link + subscribe + sale) + param));
  };

  /* 
    when choosing 'One Time Payment' or 'subscribe'
  */
  // checkbox mode
  $('#purchaseMode input[type=checkbox]').on('click', function () {
    let checkboxType;

    if ($('.cart__details').attr('data-check') === 'un-subscribe') {
      $('.cart__details').attr('data-check', 'subscribe');

      if (!$('#purchaseDisclaimer').hasClass('purchaseTypeWrap--open')) {
        $('#purchaseDisclaimer').addClass('purchaseTypeWrap--open');
        $('#cartCTA').addClass('disabled');
      }

      if ($('body').hasClass('show-promoBanner')) {
        $('body').addClass('show-promoBanner--club');
      }

      checkboxType = true;

    } else {
      $('.cart__details').attr('data-check', 'un-subscribe');

      if ($('#purchaseDisclaimer').hasClass('purchaseTypeWrap--open')) {
        $('#purchaseDisclaimer').removeClass('purchaseTypeWrap--open');
        $('#cartCTA').removeClass('disabled');

      }

      if ($('#disclaimerTrigger').hasClass('checked')) {
        $('#disclaimerTrigger').removeClass('checked');
      }

      if ($('body').hasClass('show-promoBanner')) {
        $('body').removeClass('show-promoBanner--club');
      }

      checkboxType = false;
    }

    this.setAttribute('checked', checkboxType);

    $('.cart__product.active').each(activeProduct);
  });

  // toggle mode
  $('.subscribe-box__default').on('click', function () {
    let thisBtn = $(this),
        checkboxWrap = $('.subscribe-box__wrap');

    if ($('.cart__details').attr('data-check') === 'un-subscribe') {
      $('.cart__details').attr('data-check', 'subscribe');

      if (!$('#purchaseDisclaimer').hasClass('purchaseTypeWrap--open')) {
        $('#purchaseDisclaimer').addClass('purchaseTypeWrap--open');
        $('#cartCTA').addClass('disabled');
      }

      if ($('body').hasClass('show-promoBanner')) {
        $('body').addClass('show-promoBanner--club');
      }

    } else {
      $('.cart__details').attr('data-check', 'un-subscribe');

      if ($('#purchaseDisclaimer').hasClass('purchaseTypeWrap--open')) {
        $('#purchaseDisclaimer').removeClass('purchaseTypeWrap--open');
        $('#cartCTA').removeClass('disabled');

      }

      if ($('#disclaimerTrigger').hasClass('checked')) {
        $('#disclaimerTrigger').removeClass('checked');
      }

      if ($('body').hasClass('show-promoBanner')) {
        $('body').removeClass('show-promoBanner--club');
      }

    }

    $('.subscribe-box__default').toggleClass('active');
    checkboxWrap.toggleClass('isSubscribe');

    if (thisBtn.hasClass('subscribe active')) {
      $('html, body').animate({
        scrollTop: $("#topSection").offset().top
      }, 1000);
    }

    $('.cart__product.active').each(activeProduct);
  });

  $('#disclaimerTrigger').on('click', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('checked') && $('#cartCTA').hasClass('disabled')) {
      $(this).addClass('checked');
      $('#cartCTA').removeClass('disabled');

    } else {
      $(this).removeClass('checked');
      $('#cartCTA').addClass('disabled');
    }
  });

  $('.cart__product').on('click', activeProduct);
  $('.cart__product.active').trigger("click");

  //- Set current Year to footer Copyright
  let thisDate = new Date();
  $('#year').html(thisDate.getFullYear());
});
